import React, { useEffect, useState } from 'react';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Showcase from './components/Showcase';
import Generator from './components/Generator';
import Footer from './components/Footer';
import Login from './components/Login';
import MyWorks from './components/MyWorks';
import PointsRecharge from './components/PointsRecharge';
import { useAuth } from './context/AuthContext';
import './App.css';

function AppContent() {
  const [language, setLanguage] = useState('en');
  const [currentPage, setCurrentPage] = useState('home'); // home, works, recharge, orders
  const { showLogin, user } = useAuth();

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'zh' : 'en');
  };

  useEffect(() => {
    const handleClickOutside = () => {
      const list = document.getElementById('duration-options');
      if (list && list.classList.contains('show')) {
        list.classList.remove('show');
        const icon = document.querySelector('.duration-trigger i');
        if (icon) icon.style.transform = 'rotate(0deg)';
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // 监听认证过期事件
  useEffect(() => {
    const handleAuthExpired = () => {
      console.log('Token expired, reloading page...');
      // Token 过期时，页面会在 api.js 中自动清理并触发 reload
    };

    window.addEventListener('auth-expired', handleAuthExpired);
    return () => {
      window.removeEventListener('auth-expired', handleAuthExpired);
    };
  }, []);

  // 渲染当前页面
  const renderPage = () => {
    switch (currentPage) {
      case 'works':
        return <MyWorks language={language} />;
      case 'recharge':
        return <PointsRecharge language={language} setCurrentPage={setCurrentPage} />;
      case 'orders':
        return (
          <div className="page-container">
            <div className="page-content">
              <h2 style={{ color: '#00f0ff', marginBottom: '20px' }}>
                {language === 'zh' ? '我的订单' : 'My Orders'}
              </h2>
              <p style={{ color: '#888' }}>
                {language === 'zh'
                  ? '订单管理功能正在开发中，敬请期待...'
                  : 'Order management feature is coming soon...'}
              </p>
            </div>
          </div>
        );
      default:
        // home page
        return (
          <>
            <HeroSection language={language} setCurrentPage={setCurrentPage} />
            {user && (
              <div className="home-my-works-section">
                <MyWorks language={language} isEmbedded={true} />
              </div>
            )}
            <Showcase language={language} />
          </>
        );
    }
  };

  return (
    <div className="App">
      <div className="bg-layer"></div>
      <div className="stars"></div>
      <div className="tech-glow"></div>

      <Header
        language={language}
        toggleLanguage={toggleLanguage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <main className={`main-content ${currentPage !== 'home' ? 'page-view' : ''}`}>
        {renderPage()}
      </main>

      <Footer language={language} />

      {showLogin && <Login language={language} />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;